/* src/app/components/export-data/export-data.component.scss */
.exports-div {
  padding: 0 15px 25px;
  margin-top: 5px;
  height: auto;
  max-height: 180px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: justify;
}
.form-button {
  width: 90px;
  margin: 0;
}
.header {
  border-bottom: solid 1px #ccc;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
.header span {
  font-size: 14px;
  font-weight: bold;
}
.grid-content {
  font-size: 14px;
}
.sticky-header {
  top: 0;
  position: sticky;
  z-index: 1000;
  background-color: #fff;
}
.larger-title-font-size {
  font-size: 1.2em;
}
.export-data-icon {
  color: #0071bb;
  font-size: 1.3em;
}
.status-block {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}
.tooltip-span {
  font-family:
    "Helvetica Neue",
    "Helvetica",
    "Arial",
    sans-serif,
    "-apple-system",
    "BlinkMacSystemFont" !important;
  font-size: 14px !important;
  font-weight: normal !important;
}
.tooltip-span:hover {
  font-family:
    "Helvetica Neue",
    "Helvetica",
    "Arial",
    sans-serif,
    "-apple-system",
    "BlinkMacSystemFont" !important;
  font-size: 14px !important;
  font-weight: normal !important;
}
#deleteDialog_dialog-content {
  padding: 0;
}
.panel {
  border: none !important;
}
.buttons-div {
  padding: 20px;
}
.customtooltip {
  word-break: break-word;
}
/*# sourceMappingURL=export-data.component.css.map */
